module.exports = __webpack_public_path__ + "img/d3.png";